
































































import { Component, VModel, Vue, Watch } from 'vue-property-decorator';

import authModule from '@/store/Auth';

import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import SidebarInfo from '@/components/common/SidebarInfo.vue';
import AvatarUpload from '@/components/common/AvatarUpload.vue';

@Component({
  components: {
    SidebarInfo,
    AvatarUpload,
  },
})
export default class WelcomeDialog extends Vue {
  @VModel() show: boolean;

  isPublic = false;

  username = '';

  get user() {
    return authModule.user;
  }

  skip() {
    Cookies.set('wt-profile', 'true', {
      expires: dayjs()
        .add(30, 'days')
        .toDate(),
    });
    this.show = false;
  }

  save() {
    authModule.setProfileInfo({
      username: this.username,
      isPublic: this.isPublic,
    });
  }

  @Watch('show', { immediate: true })
  showChanged() {
    this.username = authModule.user ? authModule.user.name : '';
    this.isPublic = !!authModule.user && authModule.user.isPublic;
  }
}
